/* unplugin-vue-components disabled */import { render } from "./welfare_details_brief.vue?vue&type=template&id=62641028&scoped=true"
import script from "./welfare_details_brief.vue?vue&type=script&lang=js"
export * from "./welfare_details_brief.vue?vue&type=script&lang=js"

import "./welfare_details_brief.vue?vue&type=style&index=0&id=62641028&style=true&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62641028"]])

export default __exports__